import { NgModule } from '@angular/core';
import { LoanService } from 'src/app/services/loan/loan.service';
import { SharedModule } from 'src/app/shared/shared.module';
import { OrderVoiVoeComponent, TwnComponent, VoiVoeHistoryComponent } from '.';
import { TableModule } from 'primeng/table';
import { InviteAllowedProductsDialogComponent } from './components/order-voi-voe/invite-allowed-products-dialog/invite-allowed-products-dialog.component';
import { RefreshOrderDialogComponent } from './components/order-voi-voe/refresh-order-dialog/refresh-order-dialog.component';
import { ServiceReadinessModule } from '../service-readiness/service-readiness.module';

@NgModule({
    imports: [
        SharedModule,
        TableModule,
        ServiceReadinessModule
    ],
    declarations: [TwnComponent, OrderVoiVoeComponent, VoiVoeHistoryComponent, InviteAllowedProductsDialogComponent, RefreshOrderDialogComponent],
    exports: [TwnComponent, OrderVoiVoeComponent, VoiVoeHistoryComponent, RefreshOrderDialogComponent],
    providers: [LoanService]
})
export class TwnModule {
  constructor() {}
}
